import React, { useState, useEffect } from 'react';
import './ImageSlider.css';

function ImageSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const slides = [
    {
      image: '/images/slider_01.png',
      title: '',
      subtitle: ''
    },
    {
      image: '/images/slider_02.png',
      title: '',
      subtitle: ''
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => 
        prevIndex === slides.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? slides.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === slides.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <section className="image-slider">
      {/* Blurred Background */}
      <div 
        className="slider-background"
        style={{
          backgroundImage: `url(${slides[currentIndex].image})`
        }}
      ></div>
      
      <div className="slider-container">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`slide ${index === currentIndex ? 'active' : ''}`}
          >
            <img 
              src={slide.image} 
              alt={slide.title}
              className="slide-image"
              loading="eager"
              onError={(e) => {
                console.error('Image failed to load:', slide.image);
                e.target.onerror = null;
                e.target.src = '/images/banner-1.jpg';
              }}
              onLoad={(e) => {
                e.target.style.opacity = '1';
              }}
            />
            <div className="slide-overlay"></div>
            {(slide.title || slide.subtitle) && (
              <div className="slide-content">
                {slide.title && <h2 className="slide-title">{slide.title}</h2>}
                {slide.subtitle && <p className="slide-subtitle">{slide.subtitle}</p>}
              </div>
            )}
          </div>
        ))}

        {/* Navigation Arrows */}
        <button className="slider-arrow slider-arrow-left" onClick={goToPrevious} aria-label="Previous slide">
          ‹
        </button>
        <button className="slider-arrow slider-arrow-right" onClick={goToNext} aria-label="Next slide">
          ›
        </button>

        {/* Dots Indicator */}
        <div className="slider-dots">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            ></button>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ImageSlider;
